
<form [formGroup]="formG1">

	<div style="display: flex; flex-flow: column nowrap; gap: 1em;">

		<div style="flex-grow: 1;">

			<triv-input [fGroup]="formG1" [data]="myInputs.name"></triv-input>

			<div
				*ngIf="bIsDuplicate"
				class="uniqueMsg"
			>
				<span class="material-icons" style="vertical-align: bottom;">report_problem</span>
				Eine andere Kategorie hat bereits diesen Namen!
			</div>

		</div>

		<triv-input [fGroup]="formG1" [data]="myInputs.description"></triv-input>

		<triv-input [fGroup]="formG1" [data]="myInputs.email"></triv-input>


		<div
			*ngIf="!group.id"
			style="margin-top: 2em; display: flex; flex-flow: row; justify-content: center; gap: 2em;"
		>

			<button
				mat-raised-button 
				*ngIf="!group.id"
				[disabled]="bSaving"
				(click)="cancel()"
			>
				<span class="material-icons">undo</span>
				Abbrechen
			</button>

			<button
				mat-raised-button
				color="primary" 
				(click)="save()" 
				[disabled]="!formG1.valid || formG1.pristine || bSaving"
			>
				<span class="material-icons">save</span>
				Erstellen
			</button>

		</div>

		@if( bSaving ) {
			<mat-progress-bar mode="indeterminate" />
		}

		@if( bError ) {
			<div class="errorMessage">
				<span class="material-icons" style="vertical-align: bottom;">report_problem</span>
				Beim Speichern der Kategorie ist ein Fehler aufgetreten
			</div>
		}

	</div>

</form>
